'use client';

/**
 * app/help/_components/FaqDeepLink.tsx
 *
 * Thin client wrapper that handles URL hash deep-linking for the FAQ accordion.
 * On mount, checks window.location.hash; if it matches a FAQ item ID
 * (format: #faq-<slug>), opens that <details> element and scrolls to it.
 *
 * Without JS: the anchor still scrolls to the correct position (the
 * <details> element is in the DOM at the correct scroll position), but
 * the accordion remains closed. JS opens it.
 *
 * This is the only client-side JS in the FAQ section — the accordion
 * open/close is native <details>/<summary> with zero JS required.
 *
 * Added: Vela, feat/help-page-migration-2026-05-12
 */

import { useEffect } from 'react';

export default function FaqDeepLink() {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || !hash.startsWith('#faq-')) return;

    const id = hash.slice(1); // e.g. "faq-failed-payment-grace-period"
    const el = document.getElementById(id);
    if (!el) return;

    // Open the <details> element
    if (el.tagName === 'DETAILS') {
      el.setAttribute('open', '');
    }

    // Smooth scroll with a slight delay so the element is expanded first
    setTimeout(() => {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }, []);

  return null; // no visual output
}
